import {SET_ENRICH_PRODUCTS,SET_ENRICH_PRODUCT,POST_ENRICH_PRODUCT,ENRICH_PRODUCT_SKIP,
        INIT_ENRICH_PRODUCT} from '../actions/types'

const initialState = {
    initEnrichProduct : '',
    enrichProducts: {},
    postEnrichProductResponse : {},
    skipEnrichProductResponse : {}
}



export default (state=initialState,action) => {

    switch(action.type){
        case INIT_ENRICH_PRODUCT : {
            let newState = {...state}
            newState.initEnrichProduct = action.payload
            return newState
        }
        case SET_ENRICH_PRODUCTS: {
            let newState = {...state};
            newState.enrichProducts = action.payload.data;
            return newState;
        }
        case SET_ENRICH_PRODUCT : {
            let newState = {...state};
            return newState;
        }
        case POST_ENRICH_PRODUCT : {
            let newState = {...state}
            newState.postEnrichProductResponse = action.payload
            return newState;
        }
        case ENRICH_PRODUCT_SKIP : {
            let newState = {...state}
            newState.skipEnrichProductResponse = action.payload;
            return newState;
        }
        default: {
            return state;
        }
    }
    return state;
}


